import { useEffect, useState } from "react";
import * as S from "./cart-drawer.styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { useCart } from "../../hooks/use-cart-hook";
import { CartItem } from "./components/cart-item/cart-item";
import { EmptyCart } from "./components/empty-cart/empty-cart";
import { formatCurrency } from "../../utils/format-currency";

export const CartDrawer = () => {
    const {
        isCartOpen,
        closeCart,
        items,
        total,
        increaseItem,
        decreaseItem,
        removeItem,
        loading,
    } = useCart();

    const [isVisible, setIsVisible] = useState(isCartOpen);

    useEffect(() => {
        if (isCartOpen) {
            setIsVisible(true);
        } else {
            const timer = setTimeout(() => setIsVisible(false), 300);
            return () => clearTimeout(timer);
        }
    }, [isCartOpen]);

    if (!isVisible && !isCartOpen) return null;

    return (
        <S.Overlay $open={isCartOpen} onClick={closeCart}>
            <S.Drawer $open={isCartOpen} onClick={(e) => e.stopPropagation()} data-cart-drawer>
                <S.Header>
                    <h4>Carrinho</h4>
                    <S.IconButton onClick={(e) => {
                        e.stopPropagation();
                        closeCart();
                    }} aria-label="Fechar carrinho">
                        <FontAwesomeIcon icon={faClose} />
                    </S.IconButton>
                </S.Header>

                <S.Body>
                    {loading ? (
                        <div className="py-12 text-center text-muted-foreground">
                            Carregando...
                        </div>
                    ) : items.length > 0 ? (
                        items.map((item) => (
                            <CartItem
                                key={item.id}
                                id={item.id}
                                name={item.name}
                                image={item.image ?? ""}
                                price={formatCurrency(item.pricing?.price ?? 0)}
                                quantity={item.stock?.quantity ?? 1}
                                onIncrease={() => increaseItem(item.id)}
                                onDecrease={() => decreaseItem(item.id)}
                                onRemove={() => removeItem(item.id)}
                            />
                        ))
                    ) : (
                        <EmptyCart />
                    )}
                </S.Body>

                {items.length > 0 && (
                    <S.Footer>
                        <S.TotalBar>
                            <p>Valor total:</p>
                            <span>{formatCurrency(total)}</span>
                        </S.TotalBar>
                        <S.CheckoutButton
                            href="/checkout"
                            aria-label="Ir para o checkout"
                        >
                            Ir para a compra
                        </S.CheckoutButton>
                    </S.Footer>
                )}
            </S.Drawer>
        </S.Overlay>
    );
};
